export default __webpack_public_path__ + "static/media/V660_CoC.99ddea41.pdf";